import React from 'react';
import {
	Box,
	Container,
	Grid,
	Drawer,
	makeStyles,
	Divider,
	Avatar,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Chip,
	Radio,
	RadioGroup,
	FormControlLabel,
	FormControl,
	FormLabel,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Skeleton from '@material-ui/lab/Skeleton';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import { toggleFlightModal } from '../../reducers/UiReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { FlightFareRuleEtravDispatch } from '../../reducers/HomeReducer';
import {
	setFlightId,
	setSelectedselectedReturn,
} from '../../reducers/UiReducer';
import { useState } from 'react';
const CardFlight = ({ item, index, selectedReturn }) => {
	const { flightId } = useSelector((state) => state.ui);
	const { loading } = useSelector((state) => state.home);
	const [data, setData] = useState(false);
	const dispatch = useDispatch();
	function convertH2M(timeInHour) {
		var timeParts = timeInHour.split(':');
		return Number(timeParts[0]) * 60 + Number(timeParts[1]);
	}
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	return (
		<>
			<Box
				onClick={() => dispatch(setFlightId(index))}
				style={{
					padding: 10,
					boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
					background: index === flightId ? 'rgba(57,201,187,.14)' : 'white',
					border: index === flightId ? '1px solid #39c9bb' : '',
					color: index === flightId ? '#666' : '',
					cursor: 'pointer',
				}}>
				<Box display='flex' justifyContent='space-between'>
					<Box display='flex' alignItems='center'>
						<img
							src={`https://nitish.musafirbazar.com/static/media/${
								item.AirlineCode
									? item.AirlineCode
									: item.Airline_Code
									? item.Airline_Code
									: item.AirlineCode
							}.gif`}
							width='50px'
							height='25px'></img>
						<Box alignItems='center' ml={'5px'}>
							{loading ? (
								<Skeleton variant='text' />
							) : (
								<span
									style={{
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
										color: '#3c3c3c',
									}}>
									{loading ? (
										<Skeleton variant='text' width='60px' />
									) : item.Airline_Code ? (
										item.Segments[0].Airline_Name
									) : (
										item.Segments[0].slice(0, 1).map((i) => {
											return i.Airline.AirlineName;
										})
									)}
								</span>
							)}
							{loading ? (
								<Skeleton variant='text' />
							) : (
								<BodyText
									three
									textStyle={{
										fontFamily: 'Roboto Serif, sans-serif',
										// color: '#8f8f8f',

										fontWeight: 600,
									}}>
									{item.Airline_Code
										? item.Segments[0].Airline_Code
										: item.AirlineCode
										? item.Segments[0].slice(0, 1).map((i) => {
												return i.Airline.AirlineCode;
										  })
										: ''}
									-
									{item.Airline_Code
										? item.Segments[0].Flight_Number
										: item.AirlineCode
										? item.Segments[0].slice(0, 1).map((i) => {
												return i.Airline.FlightNumber;
										  })
										: ''}
								</BodyText>
							)}
						</Box>
					</Box>
					<Box alignItems='center' display='flex'>
						{loading ? (
							<Skeleton variant='text' width='50px' />
						) : (
							<TitleText
								textStyle={{
									fontFamily: 'Josefin Sans, sans-serif',
									fontWeight: 500,
									fontSize: 22,
								}}>
								₹{' '}
								{item.Airline_Code
									? Number(
											Math.round(item.Fares[0].FareDetails[0].Basic_Amount)
									  ) +
									  Number(
											Math.round(item.Fares[0].FareDetails[0].AirportTax_Amount)
									  ) -
									  Number(
											Math.round(item.Fares[0].FareDetails[0].Net_Commission)
									  ) +
									  Number(
											Math.round(
												true ? 0 : item.Fares[0].FareDetails[0].agentMarkup
											)
									  ) +
									  Number(Math.round(item.Fares[0].FareDetails[0].TDS))
									: Number(Math.round(item.Fare.BaseFare)) +
									  Number(Math.round(item.Fare.Tax)) +
									  Number(Math.round(item.Fare.TdsOnPLB)) +
									  Number(Math.round(true ? 0 : item.Fare.agentMarkup)) -
									  Number(Math.round(item.Fare.CommissionEarned)) -
									  Number(Math.round(item.Fare.PLBEarned)) +
									  Number(Math.round(item.Fare.TdsOnCommission))}
							</TitleText>
						)}

						{/* <MoreVertIcon onClick={() => setData(true)} /> */}
					</Box>
				</Box>
				<Box display='flex' justifyContent='space-between' alignItems='center'>
					<Box>
						{loading ? (
							<Skeleton variant='text' width='50px' />
						) : (
							<TitleText
								three
								textStyle={{
									fontFamily: 'Josefin Sans, sans-serif',
									fontWeight: 500,
									fontSize: 14,
								}}>
								{item.Origin
									? item.Origin
									: item.AirlineCode
									? item.FareRules[0].Origin
									: ''}
							</TitleText>
						)}
						{loading ? (
							<Skeleton variant='text' width='50px' />
						) : (
							<TitleText three textStyle={{ fontSize: 14 }}>
								{item.Airline_Code
									? item.Segments[0].Departure_DateTime.substr(11, 5)
									: item.AirlineCode
									? item.Segments[0].slice(0, 1).map((i) => {
											return i.Origin.DepTime.substr(11, 5);
									  })
									: ''}
							</TitleText>
						)}
					</Box>
					<Box alignItems='center' textAlign='center'>
						{loading ? (
							<Skeleton variant='text' />
						) : (
							<BodyText
								textStyle={{
									color: 'rgb(239, 51, 57)',
									fontWeight: 700,
									fontSize: 16,
								}}>
								{timeConvert(
									item.Airline_Code
										? item.Segments.length === 2
											? Number(
													convertH2M(
														item.Segments.filter((i, index) => index === 0).map(
															(it) => it.Duration
														)[0]
													)
											  ) +
											  Number(
													convertH2M(
														item.Segments.filter((i, index) => index === 1).map(
															(it) => it.Duration
														)[0]
													)
											  )
											: item.Segments.length === 1
											? Number(
													convertH2M(
														item.Segments.filter((i, index) => index === 0).map(
															(it) => it.Duration
														)[0]
													)
											  )
											: item.Segments.length === 3
											? Number(
													convertH2M(
														item.Segments.filter((i, index) => index === 0).map(
															(it) => it.Duration
														)[0]
													)
											  ) +
											  Number(
													convertH2M(
														item.Segments.filter((i, index) => index === 1).map(
															(it) => it.Duration
														)[0]
													)
											  ) +
											  Number(
													convertH2M(
														item.Segments.filter((i, index) => index === 2).map(
															(it) => it.Duration
														)[0]
													)
											  )
											: ''
										: item.AirlineCode
										? item.Segments[0].length == 2
											? Number(
													item.Segments[0]
														.filter((i, index) => index === 0)
														.map((it) => {
															return it.Duration;
														})
											  ) +
											  Number(
													item.Segments[0]
														.filter((i, index) => index === 1)
														.map((it) => {
															return it.Duration;
														})
											  )
											: item.Segments[0].length == 1
											? item.Segments[0].map((i) => i.Duration)
											: item.Segments[0].length == 3
											? Number(
													item.Segments[0]
														.filter((i, index) => index === 0)
														.map((it) => {
															return it.Duration;
														})
											  ) +
											  Number(
													item.Segments[0]
														.filter((i, index) => index === 1)
														.map((it) => {
															return it.Duration;
														})
											  ) +
											  Number(
													item.Segments[0]
														.filter((i, index) => index === 2)
														.map((it) => {
															return it.Duration;
														})
											  )
											: ''
										: ''
								)}
							</BodyText>
						)}

						<BodyText
							two
							textStyle={{
								color: 'green',
								fontWeight: 'bold',
								fontSize: '14px',
							}}>
							{item.AirlineCode
								? item.Segments[0].length === 1
									? 'Non Stop'
									: item.Segments[0].length === 2
									? '2 Stop'
									: item.Segments[0].length === 3
									? '3 Stop'
									: ''
								: item.Segments.length === 1
								? 'Non Stop'
								: item.Segments.length === 2
								? '2 Stop'
								: item.Segments.length === 3
								? '3 Stop'
								: ''}
						</BodyText>
					</Box>
					<Box>
						{loading ? (
							<Skeleton variant='text' width='50px' />
						) : (
							<TitleText
								three
								textStyle={{
									fontFamily: 'Josefin Sans, sans-serif',
									fontWeight: 500,
									fontSize: 14,
								}}>
								{item.Airline_Code
									? item.Segments.length === 1
										? item.Segments.filter((i, index) => index === 0).map(
												(it) => {
													return it.Destination;
												}
										  )
										: item.Segments.length === 2
										? item.Segments.filter((i, index) => index === 1).map(
												(it) => {
													return it.Destination;
												}
										  )
										: item.Segments.length === 3
										? item.Segments.filter((i, index) => index === 2).map(
												(it) => {
													return it.Destination;
												}
										  )
										: ''
									: item.AirlineCode
									? item.Segments[0].length == 2
										? item.Segments[0]
												.filter((i, index) => index === 1)
												.map((it) => {
													return it.Destination.Airport.AirportCode;
												})
										: item.Segments[0].length == 3
										? item.Segments[0]
												.filter((i, index) => index === 2)
												.map((it) => {
													return it.Destination.Airport.AirportCode;
												})
										: item.Segments[0].length == 1
										? item.Segments[0].map((it) => {
												return it.Destination.Airport.AirportCode;
										  })
										: ''
									: ''}
							</TitleText>
						)}
						{loading ? (
							<Skeleton variant='text' width='50px' />
						) : (
							<TitleText three textStyle={{ fontSize: 14 }}>
								{item.Airline_Code
									? item.Segments.length === 1
										? item.Segments.filter((i, index) => index === 0).map(
												(it) => {
													return it.Arrival_DateTime.substr(11, 5);
												}
										  )
										: item.Segments.length === 2
										? item.Segments.filter((i, index) => index === 1).map(
												(it) => {
													return it.Arrival_DateTime.substr(11, 5);
												}
										  )
										: item.Segments.length === 3
										? item.Segments.filter((i, index) => index === 2).map(
												(it) => {
													return it.Arrival_DateTime.substr(11, 5);
												}
										  )
										: ''
									: item.AirlineCode
									? item.Segments[0].length == 3
										? item.Segments[0]
												.filter((i, index) => index === 2)
												.map((i) => {
													return i.Destination.ArrTime.substr(11, 5);
												})
										: item.Segments[0].length == 2
										? item.Segments[0]
												.filter((i, index) => index === 1)
												.map((i) => {
													return i.Destination.ArrTime.substr(11, 5);
												})
										: item.Segments[0].length == 1
										? item.Segments[0]
												.filter((i, index) => index === 0)
												.map((i) => {
													return i.Destination.ArrTime.substr(11, 5);
												})
										: ''
									: ''}
							</TitleText>
						)}
					</Box>
				</Box>
			</Box>
			<Box
				style={{
					padding: '10px 10px',
					background: '#f5f6f6',
					borderBottomLeftRadius: '4px',
					borderBottomRightRadius: '4px',
					// font-size: var(--fnt-11);
					borderTop: '1px solid #e2e2e2',
					// font-size: var(--fnt-12);
					color: '#666',
				}}>
				<Box justifyContent='space-between' alignItems='center' display='flex'>
					<Box display='flex' alignItems='center'>
						{loading ? (
							<Skeleton variant='text' width='60px' height='40px' />
						) : (
							<Box
								style={{
									padding: '2px 10px',
									background: item.AirlineCode
										? item.FareClassification
											? item.FareClassification.Color
											: ''
										: '#f56d6d',
									borderRadius: 4,
									boxShadow: '3px 3px 12px -6px rgb(0 0 0 / 70%)',
								}}>
								<BodyText
									textStyle={{
										color: item.AirlineCode
											? item.FareClassification
												? item.FareClassification.Color === 'Blue'
													? 'white'
													: 'black'
												: 'white'
											: 'white',
									}}>
									{item.AirlineCode
										? item.FareClassification?.Type
										: item.Fares[0].Warning === null ||
										  item.Fares[0].Warning === ''
										? 'Fare Type'
										: 'MBFARE'}
								</BodyText>
							</Box>
						)}
						{item.Supplier == 'TBO' ? (
							item.IsRefundable ? (
								<span
									style={{
										color: 'white',
										marginLeft: 15,
										background: 'green',
										padding: '2px 10px',
										borderRadius: 5,
										fontSize: 12,
									}}>
									Refundable
								</span>
							) : (
								<span
									style={{
										color: 'white',
										marginLeft: 15,
										background: 'red',
										padding: '2px 10px',
										borderRadius: 5,
										fontSize: 12,
									}}>
									Non-Refundable
								</span>
							)
						) : item.Fares[0].Refundable ? (
							<span
								style={{
									color: 'white',
									marginLeft: 15,
									background: 'green',
									padding: '2px 10px',
									borderRadius: 5,
									fontSize: 12,
								}}>
								Refundable
							</span>
						) : (
							<span
								style={{
									color: 'white',
									marginLeft: 15,
									background: 'red',
									padding: '2px 10px',
									borderRadius: 5,
									fontSize: 12,
								}}>
								Non-Refundable
							</span>
						)}
					</Box>
					<Box
						onClick={() => {
							dispatch(toggleFlightModal(true));
							dispatch(setSelectedselectedReturn(selectedReturn));
						}}
						display='flex'>
						<span>Flight Details</span>
						<ArrowDropDownIcon />
					</Box>
				</Box>
				<Box>
					<span
						style={{
							fontSize: 11,
							color: 'rgb(239, 51, 57)',
							fontWeight: 600,
						}}>
						{item.AirlineCode
							? item.FareClassification?.Type
							: item.Fares[0].Warning === null || item.Fares[0].Warning === ''
							? ''
							: 'SPECIAL FARE. IT MAY TAKE 20-30 MINS FOR ISSUANCE. ISSUANCE DEPENDS UPON AVAILABILITY. PASSENGER NAME WILL BE UPDATED 12 TO 24 HOURS PRIOR TO DEPARTURE ON AIRLINE WEBSITE'}
					</span>
				</Box>
				<div
					style={{
						position: 'absolute',
						// top: -10px;
						// right: -10px;
						background: 'white',
						// font-size: var(--fnt-12);
						// color: var(--gray);
						minWidth: 340,
						height: 200,
						right: 760,
						bottom: 135,
						opacity: data ? 1 : 0,
						visibility: data ? 'visible' : 'hidden',
						transformOrigin: 'top',
						transition: 'all .3s ease-in-out',
						zIndex: 6,
						textAlign: 'left',
						// boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
					}}>
					<div onClick={() => setData(false)}>
						<Box
							display='flex'
							justifyContent='space-between'
							style={{ padding: 10, background: '#eee' }}>
							<Box>
								<TitleText two>Fare BreakUp</TitleText>
							</Box>
							<Box display='flex'>
								<TitleText two>Rs 5896</TitleText>
								<MoreVertIcon onClick={() => setData(false)} />
							</Box>
						</Box>
						<Box
							mt={'10px'}
							justifyContent='space-between'
							display='flex'
							style={{ paddingRight: 15, paddingLeft: 15 }}>
							<Box></Box>
							<Box>
								<TitleText two>ADT(s)x2</TitleText>
							</Box>
						</Box>
						<Divider />
						<Box
							mt={'5px'}
							mb={'5px'}
							display='flex'
							justifyContent='space-between'
							style={{ paddingRight: 15, paddingLeft: 15 }}>
							<Box>
								<TitleText two>Base Fare</TitleText>
							</Box>
							<Box>
								{' '}
								<TitleText two>Rs 8660</TitleText>
							</Box>
						</Box>
						<Divider />
						<Box
							mt={'5px'}
							mb={'5px'}
							display='flex'
							justifyContent='space-between'
							style={{ paddingRight: 15, paddingLeft: 15 }}>
							<Box>
								<TitleText two>Base Fare</TitleText>
							</Box>
							<Box>
								{' '}
								<TitleText two>Rs 8660</TitleText>
							</Box>
						</Box>
						<Divider />
						<Box
							mt={'5px'}
							mb={'5px'}
							display='flex'
							justifyContent='space-between'
							style={{ paddingRight: 15, paddingLeft: 15 }}>
							<Box>
								<TitleText two>Base Fare</TitleText>
							</Box>
							<Box>
								{' '}
								<TitleText two>Rs 8660</TitleText>
							</Box>
						</Box>
					</div>
				</div>
			</Box>
		</>
	);
};

export default CardFlight;
